export enum PurchaseType {
  DEALER = 'DEALER',
  PERSONAL_SECURED_LOAN = 'PERSONAL_SECURED_LOAN',
  PRIVATE_PARTY = 'PRIVATE_PARTY',
}
